export default [
  [`Европейские`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российские`, `44-46`, `46-48`, `48-50`, `50-52`, `52-54`],
  [`Высота по спинке (см)`, `70`, `72`, `74`, `75`, `78`],
  [`Ширина под проймой (см)`, `49`, `52`, `55`, `58`, `61`]
];
